import { completeTypes, createTypes, withPostSuccess } from 'redux-recompose';

import { CONTRACTS_NAMES, CONTRACTS_EVENTS, CONTRACTS_FUNCTIONS } from '#models/contracts/constants';
import * as ContractsService from '#services/ContractsService';
import ModalActions from '#redux/Modal/actions';
import { MODALS } from '#redux/Modal/constants';
import * as PeriodsService from '#services/PeriodsService';

import { PERIODS_TARGETS } from './constants';
import { mapAddedPeriods, mapAddPeriod } from './mappers';

export const actions = createTypes(
  completeTypes({
    primaryActions: ['GET_ALL_ADDED_PERIODS', 'ADD_PERIOD', 'GET_ALL_PERIODS', 'CREATE_PERIOD']
  }),
  '@@PERIODS'
);

export const actionCreators = {
  getAllAddedPeriods: () => ({
    type: actions.GET_ALL_ADDED_PERIODS,
    target: PERIODS_TARGETS.ADDED_PERIODS,
    payload: { event: CONTRACTS_EVENTS.PERIOD_ADDED, contractName: CONTRACTS_NAMES.PERIOD },
    service: ContractsService.getAllEvents,
    successSelector: mapAddedPeriods
  }),
  addPeriod: params => ({
    type: actions.ADD_PERIOD,
    target: PERIODS_TARGETS.ADD_PERIOD,
    payload: {
      functionName: CONTRACTS_FUNCTIONS.ADD_PERIOD,
      contractName: CONTRACTS_NAMES.PERIOD,
      functionParams: mapAddPeriod(params)
    },
    service: ContractsService.execFunction,
    injections: [
      withPostSuccess(dispatch => {
        dispatch(ModalActions.closeModal(MODALS.NEW_PERIOD));
      })
    ]
  }),
  createPeriod: values => ({
    type: actions.CREATE_PERIOD,
    target: PERIODS_TARGETS.CREATE_PERIOD,
    payload: values,
    service: PeriodsService.createPeriod,
    injections: [
      withPostSuccess(dispatch => {
        dispatch(actionCreators.getAllPeriodsAndCloseModal());
      })
    ]
  }),
  getAllPeriods: () => ({
    type: actions.GET_ALL_PERIODS,
    target: PERIODS_TARGETS.PERIODS,
    service: PeriodsService.getAllPeriods
  }),
  getAllPeriodsAndCloseModal: () => dispatch => {
    dispatch(actionCreators.getAllPeriods());
    dispatch(ModalActions.closeModal(MODALS.NEW_PERIOD));
  }
};

export default actionCreators;
